import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { get } from 'lodash';
import { FETCH_OFFERS_DETAILS, SET_DETAILS_TAB, CLEAR_DETAILS_DATA } from '../../redux/OffersDetails';
import { FETCH_SINGLE_CONVERSATION } from '../../redux/Conversations';
import PickupDateBarWrapperContainer from '../PickupDateBar/PickupDateBarWrapperContainer';
import DetailsTab from '../OffersDetails/Tabs/DetailsTab/DetailsTab';
import ContactTab from '../OffersDetails/Tabs/ContactTab/ContactTab';
import Conversation from '../Conversations/Conversation/Conversation';
import { DETAILS_TAB, CONTACT_TAB, CONVERSATIONS_TAB } from '../../consts/detailsTabs';
import '../OffersDetails/OfferDetails.scss';
import AuctionFormContainer from '../AuctionForm/AuctionFormContainer';
import { compose } from 'redux';
import withScopedTranslations from '../../withScopedTranslations/withScopedTranslations';
import icons from '../../helpers/Icons';
import { createUseStyles } from 'react-jss';
import { vehicleTypes } from '../../consts/vehicleTypes';
import AgriculturalMachineDetails from './AgriculturalMachineDetails';
import CamperDetails from './CamperDetails';
import MotorbikeDetails from './MotorbikeDetails';
import track, { events } from '../../helpers/track';

const OfferDetailsContainer = (props) => {
  const { vehicleType, t, details, selectedConversation, detailsActiveTab, match: { params: { offerId, }, }, } = props;
  const classes = useStyles();

  const DetailsComponent = {
    [vehicleTypes.Motorbike]: MotorbikeDetails,
    [vehicleTypes.AgriculturalMachine]: AgriculturalMachineDetails,
    [vehicleTypes.Camper]: CamperDetails,
  }[vehicleType]

  const {
    location: {
      state: { whichFolder, },
    },
  } = props;


  useEffect(() => {
    track(events.open_offer)
  }, [])

  useEffect(() => {
    props.setDetailsTab({ tabName: DETAILS_TAB, });
    props.fetchOffersDetails(offerId);
    return () => {
      props.clearDetailsData();
    }
  }, [])

  useEffect(() => {
    props.fetchOffersDetails(props.match.params.offerId);
  }, [whichFolder])

  useEffect(() => {
    props.fetchOffersDetails(props.match.params.offerId);
    if (selectedConversation === null || get(selectedConversation, 'messages')) {
      return;
    }
    props.fetchSingleConversation(get(selectedConversation, 'id'), get(props.details, 'hash_id'));
  }, [selectedConversation])


  const renderBottomBar = () => {
    const status = get(details, 'status');
    const isEasyTransportEnabled = get(details, 'easy_transport') && vehicleType === vehicleTypes.Motorbike;

    if (whichFolder === 'in_realization' && status && status !== 'picked_up') {
      return (
        <PickupDateBarWrapperContainer
          pickupDate={get(details, 'pick_up_date')}
          hashId={get(details, 'hash_id')}
          status={status}
          isEasyTransportEnabled={isEasyTransportEnabled}
        />
      );
    }

    return null;
  };

  const renderActiveTab = () => {
    switch (detailsActiveTab) {
      case CONTACT_TAB:
        return get(details, ['details', 'contact_details']) && <ContactTab />;
      case CONVERSATIONS_TAB:
        return (
          <div className="conversations-tab">
            <Conversation dontLeaveEmpty hashId={offerId} />
          </div>
        );
      default:
        return <DetailsTab offerId={offerId} />;
    }
  };

  const checkTransportStatusUrl = get(details, ['details', 'check_transport_status_url'])
  return (
    <div className="row details-container">
      <DetailsComponent whichFolder={whichFolder} />
      <div className="col-md-5 details__right-column">
        {renderActiveTab()}
        {(['browse', 'new_bets', 'my_bets', 'buy_now'].includes(whichFolder)) &&
            <>
              <AuctionFormContainer offerId={offerId} />
            </>
        }
        {((['in_realization'].includes(whichFolder)) && checkTransportStatusUrl) &&
            <>
              <a className={classes.checkTransportStatusLink} href={checkTransportStatusUrl}> {icons('delivery')}&nbsp; {t('check_tranport_status')}</a>
            </>
        }
      </div>
      {renderBottomBar()}
    </div>
  );
}

const useStyles = createUseStyles({
  detailsLeftColumn: {
    paddingLeft: '15px !important',
    paddingRight: '15px !important',
  },
  checkTransportStatusLink: {
    display: 'flex',
    alignItems: 'center',
    color: '#6dc370',
    fontSize: '15px',
    '&:hover': {
      textDecoration: 'none',
      color: '#57c2ef',
    },
  },
})

const mapStateToProps = (state) => {
  const details = get(state, ['offerDetails', 'data']);
  const selectedConversation = get(state, ['conversations', 'conversations', get(details, 'hash_id')]);
  return {
    detailsActiveTab: get(state, ['offerDetails', 'detailsActiveTab']),
    vehicleType: get(state, ['vehicleType', 'vehicleType']),
    details,
    selectedConversation,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchOffersDetails: (offerId) => dispatch(FETCH_OFFERS_DETAILS(offerId)),
    setDetailsTab: (payload) => dispatch(SET_DETAILS_TAB(payload)),
    clearDetailsData: () => dispatch(CLEAR_DETAILS_DATA()),
    fetchSingleConversation: (id, hashId) => dispatch(FETCH_SINGLE_CONVERSATION({ id, hashId, })),
  };
};

OfferDetailsContainer.propTypes = {
  location: PropTypes.object.isRequired,
  vehicleType: PropTypes.oneOfType(Object.keys(vehicleTypes)),
  match: PropTypes.object.isRequired,
  fetchOffersDetails: PropTypes.func.isRequired,
  setDetailsTab: PropTypes.func.isRequired,
  clearDetailsData: PropTypes.func.isRequired,
  fetchSingleConversation: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  selectedConversation: PropTypes.object,
  isMobile: PropTypes.bool,
  detailsActiveTab: PropTypes.string,
  details: PropTypes.shape({
    hash_id: PropTypes.string,
  }).isRequired,
};

OfferDetailsContainer.defaultProps = {
  detailsActiveTab: null,
  selectedConversation: null,
  isMobile: false,
  vehicleType: vehicleTypes.Motorbike,
};

export default compose(
  withRouter,
  withScopedTranslations('offer_details'),
  connect(mapStateToProps, mapDispatchToProps)
)(OfferDetailsContainer)

